module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_komsco_m2.8df3755822a2451d13b503d536fca27f.png";